__turbopack_context__.v({
  "blinq-app-link": "FocusLayout-module-scss-module__brUPKq__blinq-app-link",
  "focus-mode-body": "FocusLayout-module-scss-module__brUPKq__focus-mode-body",
  "focus-mode-contents": "FocusLayout-module-scss-module__brUPKq__focus-mode-contents",
  "focus-mode-edited-contents": "FocusLayout-module-scss-module__brUPKq__focus-mode-edited-contents",
  "focus-mode-editing-bar": "FocusLayout-module-scss-module__brUPKq__focus-mode-editing-bar",
  "focus-notifications-section": "FocusLayout-module-scss-module__brUPKq__focus-notifications-section",
  "layout": "FocusLayout-module-scss-module__brUPKq__layout",
  "mobile-warning": "FocusLayout-module-scss-module__brUPKq__mobile-warning",
  "mobile-warning-text": "FocusLayout-module-scss-module__brUPKq__mobile-warning-text",
});
